import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import WordPair from './WordPair';
import { useEffect } from "react";
import Helpers from "@/Helpers";

export default function WordPairs(props) {
   const { sectionData, values, setValue } = props;
   const currentSection = sectionData?.currentSection;
   const content: Record<string, unknown> = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const elements = Helpers.getSectionElements(content);
   const contentValues = Array.isArray(elements?.items) ? elements.items : [];
   const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");

   useEffect(() => {
         sectionData.registerSection( 640, contentValues.length);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentSection?.name, contentValues.length]);

   function onChange(id, value) {
      setValue(id, value ? 'TRUE' : '0');
   }

   // Split the values into two columns
   const items = contentValues;
   const half = Math.ceil(items.length / 2);
   const col1 = items.slice(0, half);
   const col2 = items.slice(half);

   return (
      <div className="page WordPairs" >
         <div className="instructions">{parseSanitizedHtml(instructionsHtml)}</div>
         <div className="content center">
            <div className="wordpairs-grid">
               <div className="wordpairs-col">
                  {col1.map((p) => (
                     <WordPair key={p.id} id={p.id} word1={p.word1} word2={p.word2} value={values[p.id]} setValue={onChange} />
                  ))}
               </div>
               <div className="wordpairs-col">
                  {col2.map((p) => (
                     <WordPair key={p.id} id={p.id} word1={p.word1} word2={p.word2} value={values[p.id]} setValue={onChange} />
                  ))}
               </div>
            </div>
         </div>
      </div>
   )
}



// const data = {
//    formId: 800,
//    id: 5,
//    name: "WordPairs",
//    caption: "Word Pairs",
//    eng: {
//       caption: "Word Pairs",
//       instructions: `<p><span className="bold">INSTRUCTIONS</span>: Different situations call for different reactions. This is why people can possess opposing qualities at the same time. On the list below, please click the circle in front of the pairs that best describe you. Click <span className="bold">ONLY</span> the circles where <span className="bold">BOTH</span> qualities apply to you, not just one of the qualities.</p>`,
//       values: [
//          { id: 1, word1: "Sensitive", word2: "Tough" },
//          { id: 2, word1: "Strong", word2: "Gentle" },
//          { id: 3, word1: "Cowardly", word2: "Courageous" },
//          { id: 4, word1: "Mature", word2: "Playful" },
//          { id: 5, word1: "Humorous", word2: "Serious" },
//          { id: 6, word1: "Distant", word2: "Friendly" },
//          { id: 7, word1: "Self-confident", word2: "Self-critical" },
//          { id: 8, word1: "Trusting", word2: "Cautious" },
//          { id: 9, word1: "Dependent", word2: "Independent" },
//          { id: 10, word1: "Impulsive", word2: "Well-organized" },
//          { id: 11, word1: "Happy", word2: "Discontent" },
//          { id: 23, word1: "Optimistic", word2: "Pessimistic" },
//          { id: 12, word1: "Cooporative", word2: "Rebellious" },
//          { id: 13, word1: "Proud", word2: "Humble" },
//          { id: 14, word1: "Selfish", word2: "Unselfish" },
//          { id: 15, word1: "Involved", word2: "Detached" },
//          { id: 16, word1: "Lazy", word2: "Hardworking" },
//          { id: 17, word1: "Logical", word2: "Creative" },
//          { id: 18, word1: "Calm", word2: "Emotional" },
//          { id: 19, word1: "Shy", word2: "Bold" },
//          { id: 20, word1: "Loving", word2: "Angry" },
//          { id: 21, word1: "Consistent", word2: "Unpredictable" },
//          { id: 22, word1: "Messy", word2: "Neat" },
//       ],
//    },
//    esp: {
//       caption: "Word Pairs",
//       instructions: `<p><span className="bold">INSTRUCCIONES</span>: Diferentes situaciones exigen diferentes reacciones. personas pueden poseer cualidades opuestas al mismo tiempo. Por eso las personas pueden poseer cualidades opuestas al mismo tiempo. En la siguiente lista, haga clic en el círculo frente a las parejas de palabras que mejor le describan. Hacer clic <span className="bold">SÓLO</span> en los círculos donde <span className="bold">AMBAS</span> cualidades se aplican a usted, no sólo una.</p>`,
//       values: [
//          { id: 1, word1: "Sensible", word2: "Duro" },
//          { id: 2, word1: "Fuerte", word2: "Suave" },
//          { id: 3, word1: "Cobarde", word2: "Valiente" },
//          { id: 4, word1: "Maduro(a)", word2: "Juguetón(a)" },
//          { id: 5, word1: "Humorístico(a)", word2: "Serio(a)" },
//          { id: 6, word1: "Distante", word2: "Amistoso(a)" },
//          { id: 7, word1: "Seguro(a) de mí mismo(a)", word2: "Autocrítico(a)" },
//          { id: 8, word1: "Confiado(a)", word2: "Cauteloso(a)" },
//          { id: 9, word1: "Dependiente", word2: "Independiente" },
//          { id: 10, word1: "Impulsivo(a)", word2: "Bien organizado(a)" },
//          { id: 11, word1: "Feliz", word2: "Descontento(a)" },
//          { id: 23, word1: "Optimista", word2: "Pesimista" },
//          { id: 12, word1: "Cooperativo(a)", word2: "Rebelde" },
//          { id: 13, word1: "Orgulloso(a)", word2: "Humilde" },
//          { id: 14, word1: "Egoísta", word2: "desinteresado(s)" },
//          { id: 15, word1: "Involucrado(a)", word2: "Desvinculado(a)" },
//          { id: 16, word1: "Perezoso(a)", word2: "Trabajador(a)" },
//          { id: 17, word1: "Lógico(a)", word2: "Creativo(a)" },
//          { id: 18, word1: "Calmado(a)", word2: "Emocional" },
//          { id: 19, word1: "Tímido", word2: "Valiente" },
//          { id: 20, word1: "Amoroso(a)", word2: "Enojado(a)" },
//          { id: 21, word1: "Consistente", word2: "Impredecible" },
//          { id: 22, word1: "Desordenado(a)", word2: "Ordenado(a)" },
//       ]
//    }
// };


